@if (
  {
    violations: violations$ | async
  };
  as STATE
) {
  <article class="advertiser-sub-sector-creation-form">
    <custom-modal-card>
      <ng-container header>
        <default-modal-header
          [title]="
            subSector()?.id
              ? 'Modifier un sous-secteur'
              : 'Créer un sous-secteur'
          "
          [description]="
            subSector()?.id
              ? 'Renseigner le champ ci-dessous pour la modification d\'un sous-secteur'
              : 'Renseigner le champ ci-dessous pour la création d\'un sous-secteur'
          "
        ></default-modal-header>
      </ng-container>
      <ng-container body>
        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="resource-form">
          <article>
            <mat-label>Nom du sous-secteur *</mat-label>
            <mat-form-field color="primary">
              <input
                matInput
                formControlName="name"
                placeholder="Nom du sous-secteur"
                trim="blur"
              />
              <mat-error
                *ngIf="
                  $any(form.get('name'))?.getError('httpError') as httpError
                "
              >
                <strong>{{ httpError }}</strong>
              </mat-error>
            </mat-form-field>
          </article>
          <article>
            <mat-label>Secteur *</mat-label>
            <ng-select
              [items]="sectorPagination.items"
              bindLabel="name"
              bindValue="id"
              [loading]="sectorPagination.loading"
              [typeahead]="sectorPagination.search$"
              (scrollToEnd)="onSectorScroll()"
              (clear)="sectorPagination.clear()"
              (search)="sectorPagination.search($event.term)"
              [virtualScroll]="true"
              [appendTo]="'body'"
              placeholder="Sélectionner le secteur"
              formControlName="parentId"
            >
            </ng-select>
          </article>

          <button
            type="submit"
            [attr.loading]="isSubmitting()"
            [disabled]="!form.valid || isSubmitting()"
            button
          >
            Enregistrer
          </button>
        </form>
      </ng-container>
    </custom-modal-card>
  </article>
}
